import { Component, EventEmitter, Output } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { Store } from '@ngxs/store';

import { LanguageService } from '../../../../../../../../shared/modules/language/services/language.service';
import { LoginWithRedirect } from '../../../../state/app.actions';

@Component({
  selector: 'sh-main-nav-mobile-footer',
  templateUrl: './main-nav-mobile-footer.component.html',
  styleUrl: './main-nav-mobile-footer.component.scss',
  standalone: false
})
export class MainNavMobileFooterComponent {
  @Output() closeMenu = new EventEmitter();

  languagesOpen$ = new BehaviorSubject(false);

  constructor(
    private readonly _store: Store,
    public languageService: LanguageService
  ) {}

  openLanguages(): void {
    this.languagesOpen$.next(true);
  }

  closeLanguages(): void {
    this.languagesOpen$.next(false);
  }

  onCloseMenu(): void {
    this.closeMenu.emit();
  }

  onLoginButtonClick(): void {
    this._store.dispatch(new LoginWithRedirect());
  }

  onSignUpButtonClick(): void {
    this._store.dispatch(
      new LoginWithRedirect({
        authorizationParams: {
          screen_hint: 'signup'
        }
      })
    );
  }
}
